import React from 'react';
import WhatsAppWebShared from '../Shared/WhatsAppWebShared';

const WhatsAppWebTelecaller = () => {
  return <WhatsAppWebShared roleTitle="Telecaller" />;
};

export default WhatsAppWebTelecaller;
